import React, { forwardRef,useEffect, useState } from 'react'
import {Form, Input, Select, DatePicker} from 'antd'
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const { TextArea } = Input;

const ContentForm = forwardRef((props,ref) => {

  useEffect(()=>{
    if(ref && ref.current && props){
      ref.current.setFieldsValue({
        username: props.selectedData.user_data.name,
        booking_item_id: props.selectedData.booking_item.id,
        date:[
          dayjs(props.selectedData.start_datetime),
          dayjs(props.selectedData.end_datetime),
        ],
        remark: props.selectedData.remark
      })
    }
  },[ref,props])

  return (
    <Form
        layout="vertical"
        ref={ref}
    >
      <Form.Item
        name="username"
        label="預約者"
      >
        <Input disabled/>
      </Form.Item>
      <Form.Item
        name="booking_item_id"
        label="預約項目"
      >
        <Select
          disabled
          style={{ width: '100%' }}
          showSearch
          placeholder="select a item"
          optionFilterProp="children"
          options={props.bookingItems.filter((item)=>item.enable)}
          fieldNames={{
            label: 'name',
            value: 'id'
          }}
        />
      </Form.Item>
      <Form.Item
        name="date"
        label="日期與時間"
      >
        <RangePicker
          disabled
          style={{ width:'100%' }}
          showTime={{
            format: 'HH:mm',
          }}
          format="YYYY-MM-DD HH:mm"
        />
      </Form.Item>
      <Form.Item
        name="remark"
        label="備註"
      >
        <TextArea rows={3} placeholder="" disabled/>
      </Form.Item>
    </Form>
  )
})
export default ContentForm
